import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {fetchAllEmployees} from "./employeeApi";

export const loadAllEmployeesAsync = createAsyncThunk(
    'onsiteDrycleaning/employees/list-all',
    async (params = {}) => {
        const response = await fetchAllEmployees(params);
        return response.data;
    }
);

export const onsiteDrycleaningEmployeeSlice = createSlice({
    name: 'onsiteDrycleaningEmployee',
    initialState: {
        filteredEmployees: [],
        filterIsApply: false,
        allEmployees: []
    },
    reducers: {
        filterEmployeesByName(state, action) {
            if (action.payload.name !== '') {
                state.filterIsApply = true;
                state.filteredEmployees = action.payload.employees.filter((employee) => {
                    return employee.name.toLowerCase().indexOf(action.payload.name.toLowerCase()) !== -1;
                });
            } else {
                state.filterIsApply = false;
                state.filteredEmployees = [];
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadAllEmployeesAsync.fulfilled, (state, action) => {
                state.allEmployees = action.payload;
                state.filteredEmployees = [];
            });
    },
});

export const {filterEmployeesByName} = onsiteDrycleaningEmployeeSlice.actions;
export const selectFilteredEmployees = (state) => state.employee.onsiteDrycleaningEmployeeReducer.filteredEmployees;
export const selectFilterIsApply = (state) => state.employee.onsiteDrycleaningEmployeeReducer.filterIsApply;
export const selectAllEmployees = (state) => state.employee.onsiteDrycleaningEmployeeReducer.allEmployees;
export default onsiteDrycleaningEmployeeSlice.reducer;
